export function findNode(id, currentNode) {
    let i,
        currentChild,
        result;

    if (Array.isArray(currentNode)) {
        // if currentNode is an array (start of tree)
        for (i = 0; i < currentNode.length; i += 1) {
            currentChild = currentNode[i];
            result = findNode(id, currentChild);
            if (result !== false) {
                return result;
            }
        }
    }
    if (id === currentNode.id) {
        return currentNode;
    }
    else {

        // Use a for loop instead of forEach to avoid nested functions
        // Otherwise "return" will not work properly
        for (i = 0; i < currentNode.categoryChildren.length; i += 1) {
            currentChild = currentNode.categoryChildren[i].child;

            // Search in the current child
            result = findNode(id, currentChild);

            // Return the result if the node has been found
            if (result !== false) {
                return result;
            }
        }

        // The node has not been found and we have no more options
        return false;
    }
}
